export default __webpack_public_path__ + "static/media/Linero4.8271f43e.png";